module.exports = __webpack_public_path__ + "static/4-2525cb4731e9b1b7c14640e7a8a67a6f.jpg";